var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgHalfStar = function SvgHalfStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "halfStar_svg__icon",
    viewBox: "0 0 1024 1024",
    width: 200,
    height: 200
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M959.95 410.506a20.014 20.014 0 00-16.155-13.619L658.332 355.41 530.672 96.735a20.01 20.01 0 00-35.887 0L367.122 355.41 81.66 396.887a20.01 20.01 0 00-11.09 34.13l206.563 201.35-48.763 284.309a20.009 20.009 0 0029.031 21.093L512.73 803.537l255.325 134.232a19.998 19.998 0 0021.072-1.524 20.007 20.007 0 007.96-19.57l-48.762-284.308 206.563-201.35a20.01 20.01 0 005.062-20.51zM712.856 611.053a20.014 20.014 0 00-5.754 17.711l43.688 254.718L522.04 763.22a20.005 20.005 0 00-9.311-2.299c-.177 0-.354.012-.532.017v-609.06l.532-1.076L627.1 382.553A20.015 20.015 0 00642.17 393.5l255.753 37.161-185.065 180.392z",
    fill: "#00B67A"
  })));
};
export default SvgHalfStar;